export default {
  expiresSoon: 'The trail of \'{appName}\' will be deactivated after {expiryDate}.',
};
